import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ProductSearchDialog } from '../../product/product-search-dialog/product-search-dialog';

@Component({
  selector: 'app-search-button',
  imports: [MatButtonModule, MatIconModule, MatDialogModule],
  templateUrl: './search-button.html',
  styleUrl: './search-button.scss',
})
export class SearchButton {
  constructor(private dialog: MatDialog) {}

  search() {
    this.dialog.open(ProductSearchDialog, {
      width: '80%',
    });
  }
}
